import type { Entity } from '@backstage/catalog-model';

import type { EntityFilter, TypedFilter } from '../types';

import { notEmpty } from './notEmpty';

export const patchTypedFilter = <T extends Entity>(
  { filter, predicate }: TypedFilter<T>,
  patch: (EntityFilter<T> | null | undefined)[] | EntityFilter<T>,
): null | TypedFilter<T> => {
  const filters = Array.isArray(filter) ? filter : [filter];
  const patches = Array.isArray(patch) ? patch.filter(notEmpty) : [patch];
  const merged = filters.flatMap(base => patches.map(update => ({ ...base, ...update })));
  const [first] = merged;
  if (!first) {
    return null;
  }
  return {
    filter: Array.isArray(filter) || Array.isArray(patch) ? merged : first,
    predicate,
  };
};
